function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Input from '../Input/Input.theme';

var AutoComplete = function AutoComplete(tokens) {
  return _extends({}, Input(tokens), {
    field: {
      backgroundColor: tokens.colors.white
    },
    list: {
      padding: {
        top: tokens.spacing.small,
        right: tokens.spacing.small,
        bottom: tokens.spacing.small,
        left: tokens.spacing.small
      },
      font: {
        size: tokens.fontSizes.small,
        weight: {
          "default": tokens.fontWeights.regular,
          matched: tokens.fontWeights.bold
        },
        lineHeight: tokens.lineHeights.small
      },
      backgroundColor: {
        "default": tokens.colors.white,
        hover: tokens.colors.clear
      }
    }
  });
};

export default AutoComplete;